import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.hanscribe.clinic');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-hanscribe-clinic',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.hanscribe.clinic/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.clinic-access-denied {
  display: flex;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 24px;
}

.clinic-access-denied__panel {
  width: min(100%, 520px);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 28px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

.clinic-access-denied__eyebrow {
  margin: 0 0 8px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
}

.clinic-access-denied h1 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0;
}

.clinic-access-denied p {
  margin: 12px 0 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.6;
}

.clinic-access-denied a {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  margin-top: 20px;
  border-radius: 6px;
  background: #0f766e;
  padding: 0 14px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}`],
})
export class PageHanscribeClinicComponent implements OnInit {
    public encounterId = '';
    public workspaceContext: any = {};
    public canOpenClinic = false;
    public accessMessage = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow("/access")) return;

        this.encounterId = this.pathEncounterId();
        const role = this.service.auth.session?.role || '';
        this.canOpenClinic = role === 'doctor' || role === 'admin';

        if (!this.canOpenClinic) {
            this.accessMessage = '요청한 작업 권한이 없습니다.';
            this.workspaceContext = {};
            await this.service.render();
            return;
        }

        this.workspaceContext = { encounter_id: this.encounterId };
        await this.service.render();
    }

    private pathEncounterId() {
        try {
            const parts = (window.location.pathname || '').split('/').filter((part) => !!part);
            const index = parts.indexOf('clinic');
            if (index >= 0 && parts[index + 1]) return decodeURIComponent(parts[index + 1]);
            return '';
        } catch (e) {
            return '';
        }
    }
}

export default PageHanscribeClinicComponent;